import { useContext } from 'react';
import { isDefined } from 'src/utils';
export const useContextRequire = (context) => {
    const requireContext = useContext(context);
    if (!isDefined(requireContext)) {
        throw new Error('Context is not defined');
    }
    return requireContext;
};
